import { format } from 'date-fns'

/**Converts array of strings/numbers to string representation, e.g. x1, x2, ...xn */
export const convertArray = (data: string[] | number[]) =>
  data.map((value) => "'" + value + "'").join(',')

/**converts js date obj to sqlite datetime format (YYYY-MM-DD HH:MM:SS) */
export const jsDateToSqlite = (date: Date) => {
  return format(date, 'yyyy-MM-dd HH:mm:ss')
}

/** Formats js date obj to sqlite date (yyyy-MM-dd) */
export const jsDateToSqliteDate = (date: Date) => {
  return format(date, 'yyyy-MM-dd')
}
